import { takeEvery, call, put } from "redux-saga/effects";
import { RECEIVABLE_LIST_REQUESTED } from "../constants/action-types";
import { receivableListLoaded, apiError } from "../actions/receivable";
import config from '../config.json';
import axios from 'axios'
import { buildAuthorizationHeader } from '../middleware/authentication';

const httpsClient = axios.create({
    baseURL: config.API.URL,
    timeout: 10000,
});

export default function* watcherSaga() {
    yield takeEvery(RECEIVABLE_LIST_REQUESTED, workerSaga);
}

function* workerSaga() {
    try {
        const payload = yield call(getData);
        yield put(receivableListLoaded(payload));
    } catch (e) {
        yield put(apiError(e));
    }
}

function getData() {
	return httpsClient.get('/receivables', { 
        'headers' : { 
            'Authorization'               : buildAuthorizationHeader(),
            'Content-Type'                : 'application/json',
        } 
    }).then(response => response.data);
}
